import { render, staticRenderFns } from "./ResultHeaders.vue?vue&type=template&id=324d87d2&scoped=true&lang=pug&"
import script from "./ResultHeaders.vue?vue&type=script&lang=js&"
export * from "./ResultHeaders.vue?vue&type=script&lang=js&"
import style0 from "./ResultHeaders.vue?vue&type=style&index=0&id=324d87d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324d87d2",
  null
  
)

export default component.exports